/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, colors, HFlow, Theme, useTheme } from 'bold-ui'
import { RadioField } from 'components/form'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { Meta } from 'util/metaPath'
import { PecIcon, PecIconProps } from 'view/atendimentos/list/PecIcon'

interface ListaTematicaRadioButtonProps {
  name: Meta<AcompanhamentoCondicaoSaudeTematicaEnum>
  label: string
  value: AcompanhamentoCondicaoSaudeTematicaEnum
  icon: PecIconProps['icon']
  onClick: (listaTematica: AcompanhamentoCondicaoSaudeTematicaEnum) => void
}

export function ListaTematicaRadioButton(props: Readonly<ListaTematicaRadioButtonProps>) {
  const { name, label, value, icon, onClick } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Button size='small' skin='outline' onClick={() => onClick(value)} style={styles.button}>
      <HFlow style={styles.content} justifyContent='space-between'>
        <RadioField name={name.absolutePath()} label={label} value={value} readOnly></RadioField>
        <PecIcon size={1.5} icon={icon} color={colors.gray.c40} />
      </HFlow>
    </Button>
  )
}

const createStyles = (theme: Theme) => ({
  button: css`
    border: solid 1px ${theme.pallete.gray.c60};
    border-radius: 2px;
    padding: 0.4rem;
  `,
  content: css`
    width: 16rem;
  `,
})
